var _excluded = ["style", "className", "defaultStatus", "sequenceType", "onChange", "disabled"];

var _SEQUENCE;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { cx } from '@emotion/css';
import SortDownIcon from "./SortDownIcon";
import SortUpIcon from "./SortUpIcon";
import { styleSort, prefix } from "./index.style";
import useThemeProps from "../../hooks/useThemeProps";
var EStatus;

(function (EStatus) {
  EStatus["DEFAULT"] = "default";
  EStatus["ASCENDING"] = "asc";
  EStatus["DESCENDING"] = "desc";
})(EStatus || (EStatus = {}));

var ESequenceType;

(function (ESequenceType) {
  ESequenceType["UPFIRST"] = "upFirst";
  ESequenceType["DOWNFIRST"] = "downFirst";
  ESequenceType["WITHOUTDEFAULT"] = "withoutDefault";
})(ESequenceType || (ESequenceType = {}));

var SEQUENCE = (_SEQUENCE = {}, _defineProperty(_SEQUENCE, ESequenceType.UPFIRST, [EStatus.DEFAULT, EStatus.ASCENDING, EStatus.DESCENDING]), _defineProperty(_SEQUENCE, ESequenceType.DOWNFIRST, [EStatus.DEFAULT, EStatus.DESCENDING, EStatus.ASCENDING]), _defineProperty(_SEQUENCE, ESequenceType.WITHOUTDEFAULT, [EStatus.DESCENDING, EStatus.ASCENDING]), _SEQUENCE);

var InternalSort = function InternalSort(props, ref) {
  var _cx;

  var style = props.style,
      className = props.className,
      defaultStatus = props.defaultStatus,
      _props$sequenceType = props.sequenceType,
      sequenceType = _props$sequenceType === void 0 ? 'upFirst' : _props$sequenceType,
      onChange = props.onChange,
      disabled = props.disabled,
      rest = _objectWithoutProperties(props, _excluded);

  var sequence = SEQUENCE[sequenceType];
  var defaultStatusCal = rest.status || defaultStatus || (sequenceType === ESequenceType.WITHOUTDEFAULT ? EStatus.ASCENDING : EStatus.DEFAULT);

  var _React$useState = React.useState(defaultStatusCal),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentStatus = _React$useState2[0],
      setCurrentStatus = _React$useState2[1];

  var currentStatusIndex = React.useRef(sequence.findIndex(function (statusItem) {
    return defaultStatusCal === statusItem;
  }));
  var isControled = Boolean('status' in rest);
  var c = useThemeProps();
  var onClickHandler = React.useCallback(function () {
    if (disabled) {
      return;
    }

    var index = 0;

    if (currentStatusIndex.current === sequence.length - 1) {
      index = 0;
    } else {
      index = currentStatusIndex.current + 1;
    }

    if (!isControled) {
      currentStatusIndex.current = index;
      setCurrentStatus(sequence[index]);
    }

    onChange === null || onChange === void 0 ? void 0 : onChange(sequence[index]);
  }, [disabled, sequence, isControled, onChange]);
  React.useEffect(function () {
    if (isControled) {
      if (rest.status) {
        var currentIndex = sequence.findIndex(function (statusItem) {
          return rest.status === statusItem;
        });
        currentStatusIndex.current = currentIndex;
        setCurrentStatus(rest.status);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [sequence, rest.status]);
  return /*#__PURE__*/React.createElement("span", _extends({}, rest, {
    className: cx(styleSort(c), (_cx = {}, _defineProperty(_cx, prefix('disabled')(), disabled), _defineProperty(_cx, prefix('default')(), EStatus.DEFAULT === currentStatus), _cx), className),
    onClick: onClickHandler,
    style: style,
    ref: ref
  }), /*#__PURE__*/React.createElement(SortUpIcon, {
    style: {
      width: '8px',
      height: '4px'
    },
    className: cx(prefix('up-icon')(), {
      active: EStatus.ASCENDING === currentStatus
    })
  }), /*#__PURE__*/React.createElement(SortDownIcon, {
    style: {
      width: '8px',
      height: '4px'
    },
    className: cx(prefix('down-icon')(), {
      active: EStatus.DESCENDING === currentStatus
    })
  }));
};

var Sort = /*#__PURE__*/React.forwardRef(InternalSort);
Sort.defaultProps = {
  disabled: false,
  sequenceType: 'upFirst'
};
Sort.displayName = 'Sort';
export default /*#__PURE__*/React.memo(Sort);